module.exports = __webpack_public_path__ + "media/application/images/icons/wiki-crumbs-arrow-726c49f98fdb02e30ee2ff23873b6ac7.svg";